import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { URL_CHANGED } from "./actions"

export type RouterState = {
    currentPath: CurrentPathType
}

export type CurrentPathType = {
    query: Record<string, Maybe<string>>
    asPath: Maybe<string>
    pathname: Maybe<string>
}

export const createDefaultRouterState = () => ({
    currentPath: {
        query: {},
        asPath: null,
        pathname: null,
    },
})
export const routerReducer = (state: Maybe<RouterState> = undefined, action: Record<string, any>) => {
    if (!state) {
        return createDefaultRouterState()
    }

    switch (action.type) {
        case URL_CHANGED:
            return {
                ...state,
                currentPath: {
                    query: action.payload.query,
                    asPath: action.payload.asPath,
                    pathname: action.payload.pathname,
                },
            }

        default:
            return state
    }
}
